import { render, staticRenderFns } from "./FaqForm.vue?vue&type=template&id=b2837d50&scoped=true&"
import script from "./FaqForm.vue?vue&type=script&lang=js&"
export * from "./FaqForm.vue?vue&type=script&lang=js&"
import style0 from "./FaqForm.vue?vue&type=style&index=0&lang=css&"
import style1 from "./FaqForm.vue?vue&type=style&index=1&id=b2837d50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2837d50",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCol,VContainer,VForm,VIcon,VRow,VSelect,VSpacer,VTextField})
